import axios from "axios";
import { API } from "./api";

// Affiliate partners have their own login, separate from Seavanto user
// accounts. Their Bearer token lives in localStorage under its own key so a
// captain can be signed in to both without the sessions mixing.
const KEY = "seavanto_aff_token";
export const affToken = {
  get() { try { return localStorage.getItem(KEY) || ""; } catch { return ""; } },
  set(t) { try { if (t) localStorage.setItem(KEY, t); } catch {} },
  clear() { try { localStorage.removeItem(KEY); } catch {} },
};

export const affApi = axios.create({ baseURL: API, withCredentials: false, timeout: 30000 });

affApi.interceptors.request.use((cfg) => {
  const t = affToken.get();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

affApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) affToken.clear();
    return Promise.reject(err);
  },
);

// Referral memory (90 days) — last click wins.
const REF_KEY = "seavanto_ref";
export const refStore = {
  set(code) {
    try {
      localStorage.setItem(REF_KEY, JSON.stringify({ code, exp: Date.now() + 90 * 86400000 }));
    } catch {}
  },
  get() {
    try {
      const v = JSON.parse(localStorage.getItem(REF_KEY) || "null");
      if (!v || !v.code || v.exp < Date.now()) return "";
      return v.code;
    } catch { return ""; }
  },
  clear() { try { localStorage.removeItem(REF_KEY); } catch {} },
};

export const usd = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(Number(n || 0));
